import { combineReducers } from 'redux';
import * as authReducer from './authReducer';
import * as  patientReducer from './patientReducer';
import * as  templateReducer from './templateReducer';
import * as  prescriptionReducer from './prescriptionReducer';
import * as consultationReducer from './consultationReducer';
import * as constantReducer from './constantReducer'
import * as queueReducer from './queueReducer'
import * as  slotReducer from './slotsReducer';
import * as appointmentReducer from './appointmentReducer';
import * as hospitalReducer from './hospitalReducer';
import * as providerReducer from './providerReducer';
import * as scheduleReducer from './scheduleReducer';

const reducers = combineReducers({
  ...authReducer,
  ...patientReducer,
  ...templateReducer,
  ...prescriptionReducer,
  ...consultationReducer,
  ...constantReducer,
  ...queueReducer,
  ...slotReducer,
  ...appointmentReducer,
  ...hospitalReducer,
  ...providerReducer,
  ...scheduleReducer
});

export default (state, action) => reducers(state, action);
